import script from "./OrgOrder.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrgOrder.vue?vue&type=script&setup=true&lang=ts"

import "./OrgOrder.vue?vue&type=style&index=0&id=49cba0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49cba0f0"]])

export default __exports__